import { render, staticRenderFns } from "./modalConfirmarPedido.vue?vue&type=template&id=72756d17&scoped=true"
import script from "./modalConfirmarPedido.vue?vue&type=script&lang=js"
export * from "./modalConfirmarPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72756d17",
  null
  
)

export default component.exports